import { createSlice } from "@reduxjs/toolkit";

export const moneyLaunderingPreventionSlice = createSlice({
  // highRankingOfficial: '',
  //        relatedHighRankingOfficial: '',
  //   relatedHighRankingOfficialName: '',
  //   relatedHighRankingOfficialRelation: '',
  //          beneficiary: '',
  //   beneficiaryName: '',
  //   beneficiaryRelation: '',
  //          felonyState: '',
  //   felony: '',
  name: "moneyLaunderingDetails",
  initialState: {
    errors: {},
    relatedHighRankingOfficialName: "", // initialize these fields
    felony: "",
    beneficiaryName: "",
  },
  reducers: {
    setAntiMoneyLaundering: (state, action) => {
      state[action.payload.name] = action.payload.value;
      state.errors[action.payload.name] = {};
      state.op = "U";
    },
    setMoneyLaunderingDetailsError: (state, action) => {
      state.errors[action.payload.name] = {};
      state.errors[action.payload.name].message = action.payload.message;
      state.errors[action.payload.name].section = action.payload.section;
    },
    clearMoneyLaunderingDetailsError: (state) => {
      state.errors = {};
    },
    setAntiMoneyLaunderingDetailData: (state, action) => {
      if (action.payload.length) {
        const dta = action.payload[0];
        Object.keys(dta).forEach((key) => (state[key] = dta[key]));
      }
    },
    //AMAN
    setRelatedHighRankingOfficialName: (state, action) => {
      state.relatedHighRankingOfficialName = action.payload;
      state.errors.relatedHighRankingOfficialNameError = {}; // clear error
      state.op = "U";
    },
    setRelatedHighRankingOfficialRelation: (state, action) => {
      state.relatedHighRankingOfficialRelation = action.payload;
      state.errors.relatedHighRankingOfficialRelationError = {}; // clear error
      state.op = "U";
    },
    setFelony: (state, action) => {
      state.felony = action.payload;
      state.errors.felonyError = {}; // clear error
      state.op = "U";
    },
    setBeneficiaryName: (state, action) => {
      state.beneficiaryName = action.payload;
      state.errors.beneficiaryNameError = {}; // clear error
      state.op = "U";
    },
    setBeneficiaryRelation: (state, action) => {
      state.beneficiaryRelation = action.payload;
      state.errors.beneficiaryRelationError = {}; // clear error
      state.op = "U";
    },


    // Error reducers for each field
    setRelatedHighRankingOfficialNameError: (state, action) => {
      if (!state.errors.relatedHighRankingOfficialNameError) {
        state.errors.relatedHighRankingOfficialNameError = {};
      }
      state.errors.relatedHighRankingOfficialNameError.message = action.payload.message;
      state.errors.relatedHighRankingOfficialNameError.section = action.payload.section;
    },
    setRelatedHighRankingOfficialRelationError: (state, action) => {
      if (!state.errors.relatedHighRankingOfficialRelationError) {
        state.errors.relatedHighRankingOfficialRelationError = {};
      }
      state.errors.relatedHighRankingOfficialRelationError.message = action.payload.message;
      state.errors.relatedHighRankingOfficialRelationError.section = action.payload.section;
    },

    setFelonyError: (state, action) => {
      if (!state.errors.felonyError) {
        state.errors.felonyError = {};
      }
      state.errors.felonyError.message = action.payload.message;
      state.errors.felonyError.section = action.payload.section;
    },
    setBeneficiaryNameError: (state, action) => {
      if (!state.errors.beneficiaryNameError) {
        state.errors.beneficiaryNameError = {};
      }
      state.errors.beneficiaryNameError.message = action.payload.message;
      state.errors.beneficiaryNameError.section = action.payload.section;
    },
    setBeneficiaryRelationError: (state, action) => {
      if (!state.errors.beneficiaryRelationError) {
        state.errors.beneficiaryRelationError = {};
      }
      state.errors.beneficiaryRelationError.message = action.payload.message;
      state.errors.beneficiaryRelationError.section = action.payload.section;
    },

    //AMAN
    setOccupationType: (state, action) => {
      state.occupationType = action.payload;
      state.errors.occupationTypeError = {};
      state.op = "U";
    },
    setBusinessType: (state, action) => {
      state.businessType = action.payload;
      state.errors.businessTypeError = {};
      state.op = "U";
    },
    setOrganizationName: (state, action) => {
      state.organizationName = action.payload;
      state.errors.organizationNameError = {};
      state.op = "U";
    },
    setAddress: (state, action) => {
      state.address = action.payload;
      state.errors.addressError = {};
      state.op = "U";
    },
    setDesignation: (state, action) => {
      state.designation = action.payload;
      state.errors.designationError = {};
      state.op = "U";
    },
    setIdNo: (state, action) => {
      state.docId = action.payload;
      state.errors.docIdError = {};
      state.op = "U";
    },
    setFinancialDetails: (state, action) => {
      state.financialDetails = action.payload;
      state.errors.financialDetailsError = {};
      state.op = "U";
    },
    setFinancialDetailsDesc: (state, action) => {
      state.financialDetailsDesc = action.payload;
    },
    setOccupationTypeDesc: (state, action) => {
      state.occupationTypeDesc = action.payload;
    },
    setSecurtitesTrading: (state, action) => {
      state.securtitesTrading = action.payload;
      state.errors.securtitesTradingError = {};
    },
    setCompanyName: (state, action) => {
      state.companyName = action.payload;
      state.errors.companyNameError = {};
    },
    setCompanyDesignation: (state, action) => {
      state.companyDesignation = action.payload;
      state.errors.companyDesignationError = {};
    },
    setCompanyDesignationDesc: (state, action) => {
      state.companyDesignationDesc = action.payload;
    },
    setCompanyNameOrRelation: (state, action) => {
      state.companyNameOrRelation = action.payload;
      state.errors.companyNameOrRelationError = {};
    },
    setCompanyNameRelation: (state, action) => {
      state.companyNameRelation = action.payload;
      state.errors.companyNameRelationError = {};
    },
    setCompanyRelationDesignation: (state, action) => {
      state.companyRelationDesignation = action.payload;
      state.errors.companyRelationDesignationError = {};
    },
    setCompanyRelationDesignationDesc: (state, action) => {
      state.companyRelationDesignationDesc = action.payload;
    },
    setRelationDesignationOthers: (state, action) => {
      state.companyRelationDesignationOthers = action.payload;
    },
    setFromAD: (state, action) => {
      state.op = "U";
      state.fromAd = action.payload;
      state.errors.fromAdError = {};
    },
    setToAD: (state, action) => {
      state.op = "U";
      state.toAd = action.payload;
      state.errors.toAdError = {};
    },
    addCompanyDetails: (state, action) => {
      console.log(action);
      state.companyDetailsList.push({
        companyName: action.payload.companyName,
        companyDesignation: action.payload.companyDesignation,
        compDesignationDesc: action.payload.compDesignationDesc,
        designationOthers: action.payload.designationOthers,
        op: "I",
      });
      // state.op = 'U';
    },
    removeCompanyDetails: (state, action) => {
      state.companyDetailsList = state.companyDetailsList.filter((company) => {
        if (company.companyName !== action.payload) {
          return true;
        } else if (company.id) {
          state.rConpanyList.push(company.id);
        }
        return false;
      });
      // state.op = 'U';
    },

    addCompanyRelationDetails: (state, action) => {
      state.companyRelationDetailsList.push({
        companyNameOrRelation: action.payload.companyNameOrRelation,
        companyNameRelation: action.payload.companyNameRelation,
        companyRelationDesignation: action.payload.companyRelationDesignation,
        companyRelationDesignationDesc: action.payload.companyRelationDesignationDesc,
        designationOthers: action.payload.companyRelationDesignationOthers,
        fromAd: action.payload.fromAd,
        toAd: action.payload.toAd,
        op: "I",
      });
      // state.op = 'U';
    },
    removeCompanyRelationDetails: (state, action) => {
      state.companyRelationDetailsList = state.companyRelationDetailsList.filter((company) => {
        if (company.companyNameOrRelation !== action.payload) {
          return true;
        } else if (company.id) {
          state.rCompanyRelationList.push(company.id);
        }
        return false;
      });
      // state.op = 'U';
    },
    setOccupationDetailData: (state, action) => {
      if (action.payload.length) {
        const dta = action.payload[0];
        Object.keys(dta).forEach((key) => (state[key] = dta[key]));
      }
    },
    resetOccupationInvetmentCompanyData: (state, action) => {
      if (action.payload.length) {
        state.companyDetailsList = [
          ...state.companyDetailsList.filter((c) => c.id),
          ...action.payload,
        ];
        state.rConpanyList = [];
      }
    },

    resetOccupationInvestmentCompanyRelationList: (state, action) => {
      if (action.payload.length) {
        state.companyRelationDetailsList = [
          ...state.companyRelationDetailsList.filter((c) => c.id),
          ...action.payload,
        ];
        state.rCompanyRelationList = [];
      }
    },
    clearOccupationData: (state, action) => {
      state.op = "N";
      state.companyDetailsList.forEach((c) => (c.op = "N"));
    },
    setOccupationTypeError: (state, action) => {
      state.errors.occupationTypeError = {};
      state.errors.occupationTypeError.message = action.payload.message;
      state.errors.occupationTypeError.section = action.payload.section;
    },
    setBusinessTypeError: (state, action) => {
      state.errors.businessTypeError = {};
      state.errors.businessTypeError.message = action.payload.message;
      state.errors.businessTypeError.section = action.payload.section;
    },
    setOrganizationNameError: (state, action) => {
      state.errors.organizationNameError = {};
      state.errors.organizationNameError.message = action.payload.message;
      state.errors.organizationNameError.section = action.payload.section;
    },
    setAddressError: (state, action) => {
      state.errors.addressError = {};
      state.errors.addressError.message = action.payload.message;
      state.errors.addressError.section = action.payload.section;
    },
    setDesignationError: (state, action) => {
      state.errors.designationError = {};
      state.errors.designationError.message = action.payload.message;
      state.errors.designationError.section = action.payload.section;
    },
    setDocIdError: (state, action) => {
      state.errors.docIdError = {};
      state.errors.docIdError.message = action.payload.message;
      state.errors.docIdError.section = action.payload.section;
    },
    setFinancialDetailsError: (state, action) => {
      state.errors.financialDetailsError = {};
      state.errors.financialDetailsError.message = action.payload.message;
      state.errors.financialDetailsError.section = action.payload.section;
    },
    setOccupationTypeOthers: (state, action) => {
      state.occupationTypeOthers = action.payload;
    },
    setBusinessTypeOthers: (state, action) => {
      state.businessTypeOthers = action.payload;
    },
    setDesignationOthers: (state, action) => {
      state.designationOthers = action.payload;
    },
    clearCompanyDetails: (state) => {
      state.companyName = "";
      state.companyDesignation = "";
    },
    clearCompanyRelationDetails: (state) => {
      state.companyNameOrRelation = "";
      state.companyNameRelation = "";
      state.companyRelationDesignation = "";
      state.fromAd = "";
      state.toAd = "";
    },
  },
});

export const {
  setAntiMoneyLaundering,
  clearMoneyLaunderingDetailsError,
  setMoneyLaunderingDetailsError,
  setAntiMoneyLaunderingDetailData,

  clearOccupationData,
  clearCompanyRelationDetails,
  setOccupationDetailData,
  setOccupationType,
  resetOccupationInvetmentCompanyData,
  resetOccupationInvestmentCompanyRelationList,
  setBusinessType,
  setOrganizationName,
  setAddress,
  setDesignation,
  setIdNo,
  setFinancialDetails,
  setSecurtitesTrading,
  setCompanyName,
  setCompanyDesignation,
  setCompanyNameOrRelation,
  setCompanyNameRelation,
  setCompanyRelationDesignation,
  setCompanyRelationDesignationDesc,
  setRelationDesignationOthers,
  addCompanyDetails,
  addCompanyRelationDetails,
  removeCompanyDetails,
  removeCompanyRelationDetails,
  setCompanyDesignationDesc,
  setFinancialDetailsDesc,
  setOccupationTypeError,
  setBusinessTypeError,
  setOrganizationNameError,
  setAddressError,
  setDesignationError,
  setDocIdError,
  setFinancialDetailsError,
  setOccupationTypeOthers,
  setBusinessTypeOthers,
  setDesignationOthers,
  setFromAD,
  setToAD,

  setRelatedHighRankingOfficialName,
  setRelatedHighRankingOfficialRelation,
  setFelony,
  setBeneficiaryName,
  setBeneficiaryRelation,
  setRelatedHighRankingOfficialNameError,
  setRelatedHighRankingOfficialRelationError,
  setFelonyError,
  setBeneficiaryNameError,
  setBeneficiaryRelationError,

  clearOccupationDetailsError,
  setOccupationTypeDesc,
  clearCompanyDetails,
} = moneyLaunderingPreventionSlice.actions;

export default moneyLaunderingPreventionSlice.reducer;
